<div
  class="bg-primary-light relative left-1/2 mb-16 flex h-48 w-[calc(100dvw-15px)] -translate-x-1/2 items-center justify-center">
  <h1 class="max-w-4xl px-4 text-center text-[30px] font-bold">
    Te damos la bienvenida al Gestor de Autorizaciones,<br />
    {{ AuthenticationService.UserCompleteName() | titlecase }}
  </h1>
</div>

<div class="flex justify-center">
  <desy-button
    id="consultar-autorizacion"
    text="Consultar autorización"
    classes="c-button--primary"
    ariaLabel="Consultar autorización"
    role="button"
    [routerLink]="['/', AuthorizationsRoutes.AUTHORIZATIONS]" />
</div>
